<template>
  <div class="app"
       @mousemove="handleUserActivity"
       @keydown="handleUserActivity"
       @touchstart="handleUserActivity"
  >
    <SideBar />
    <router-view />
    <ContactInformationPrompt />
  </div>
  <div id="modals" />
</template>

<script setup>
import { onMounted } from 'vue'
import SideBar from './components/SideBar.vue'
import ContactInformationPrompt from './components/subcomponents/ContactInformationPrompt.vue'
import { useStore } from 'vuex'
const store = useStore()
onMounted(() => {
  store.dispatch('login/startCounterOnRefresh')
})

const handleUserActivity = () => {
  store.dispatch('login/setLastActiveTick')
}

</script>

<style lang="scss">
:root {
  --mainBackground: #eeeeee;

}

@import url('https://fonts.googleapis.com/css2?family=Lexend:wght@100..900&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  //font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
  font-family: 'Lexend', sans-serif;
}

body {
  background: var(--background);
}

button {
  cursor: pointer;
  appearance: none;
  border: none;
  outline: none;
  background: none;
}

.app {
  display: flex;
  height: 100vh;

  main {
     flex: 1 1 0;
  }

  @media (max-width: 768px) {
        display:flex;
        flex-direction: column;
  }
}
</style>
